enum HandlerType {
  OrderCreator = 1,
  FlexHandler = 2,
  GmaWBHandler = 3,
  TaskHandler = 4,
  MilestoneHandler = 5,
}

export default HandlerType
